<template>
  <div class="message-group" :class="position">
    <div class="message-group__thumbnail-col" v-if="name != 'Meg'">
      <ProfilePhoto :images="thumbnail" singular></ProfilePhoto>
    </div>
    <!-- / message-group__thumbnail-col -->

    <div class="message-group__content">
      <p class="message-group__label">{{ name }}</p>
      <div class="message-group__messages">
        <slot></slot>
      </div>
      <!-- / message-group__messages -->
    </div>
    <!-- / message-group__content -->
  </div>
  <!-- / message-group -->
</template>

<script>
import ProfilePhoto from "@/components/ProfilePhoto.vue";

export default {
  name: "MessageGroup",
  components: {
    ProfilePhoto
  },
  props: {
    position: String,
    name: String,
    thumbnail: Array
  }
};
</script>

<style lang="scss">
.message-group {
  @include flex(flex-start, flex-start, nowrap);
  margin-bottom: 15px;
  padding: 0 10px;

  &__thumbnail-col {
    padding: 10px 10px 0 0;
  }

  .profile-thumbnail {
    width: 20px;
    height: 20px;
  }

  &__messages {
    @include flex(flex-start, flex-start, nowrap);
    flex-direction: column;

    .message:last-of-type {
      margin-bottom: 0;
    }

    &--right {
      .text-loader {
        margin-right: 0 !important;
        margin-left: auto;
      }
    }
  }

  &__content {
    flex: 1;
  }

  &__label {
    font-family: $font-main;
    font-size: 7px;
    letter-spacing: 0.42px;
    color: rgba($txt-color, 0.3);
    margin-bottom: 3px;

    @media #{$bigger-mobile} {
      font-size: 9px;
    }
  }

  &.left {
    .message-group {
      &__label {
        text-align: left;
      }

      &__messages {
        .message {
          &:nth-child(n + 2) {
            border-top-left-radius: 7px;
            border-bottom-left-radius: 7px;
          }

          &:first-of-type:not(:last-of-type) {
            border-top-left-radius: 20px;
            border-bottom-left-radius: 7px;
          }

          &:last-of-type {
            &:not(:first-of-type) {
              border-top-left-radius: 7px;
              border-bottom-left-radius: 20px;
            }
          }
        }
      }
    }
  }

  &.right {
    .message-group {
      &__label {
        text-align: right;
      }

      &__messages {
        align-items: flex-end;

        .message {
          color: $txt-color-alt;
          background-color: $color-primary;

          &:nth-child(n + 2) {
            border-top-right-radius: 7px;
            border-bottom-right-radius: 7px;
          }

          &:first-of-type:not(:last-of-type) {
            border-top-right-radius: 20px;
            border-bottom-right-radius: 7px;
          }

          &:last-of-type:not(:first-of-type) {
            border-top-right-radius: 7px;
            border-bottom-right-radius: 20px;
          }
        }
      }
    }
  }
}
</style>
